export default __webpack_public_path__ + "static/media/us.4c70daf4.svg";